import {
  MIN_SALES_DISPLAY_DURATION_SECONDS,
  type SalesDisplaySlide,
  type SalesDisplaySlideKind,
  type SalesDisplayWidgetKey,
} from "@/lib/sales-display-slides";

export const KIND_LABELS: Record<SalesDisplaySlideKind, string> = {
  message: "Beskjed",
  image: "Bilde",
  video: "Video",
  widget: "Salgswidget",
};

export const WIDGET_OPTIONS: Array<{
  value: Exclude<SalesDisplayWidgetKey, "pipeline">;
  label: string;
}> = [
  { value: "kpi", label: "Måltall" },
  { value: "leaderboard", label: "Salgspuls + alle selgere" },
  { value: "hall_of_fame", label: "Hall of Fame" },
];

export interface FormState {
  id?: string;
  kind: SalesDisplaySlideKind;
  title: string;
  body: string;
  durationSeconds: number;
  widgetKey: SalesDisplayWidgetKey;
  mediaPath: string | null;
  /** Signert URL til allerede lagret media. Trengs for å vise det i previewen. */
  mediaUrl: string | null;
  isActive: boolean;
}

export const EMPTY_FORM: FormState = {
  kind: "message",
  title: "",
  body: "",
  durationSeconds: MIN_SALES_DISPLAY_DURATION_SECONDS,
  widgetKey: "kpi",
  mediaPath: null,
  mediaUrl: null,
  isActive: true,
};

export function formFromSlide(slide: SalesDisplaySlide): FormState {
  return {
    id: slide.id,
    kind: slide.kind,
    title: slide.title,
    body: slide.body ?? "",
    durationSeconds: slide.durationSeconds,
    widgetKey: slide.widgetKey === "pipeline" ? "leaderboard" : slide.widgetKey ?? "kpi",
    mediaPath: slide.mediaPath,
    mediaUrl: slide.mediaUrl,
    isActive: slide.isActive,
  };
}

/**
 * Utkastet slik previewflata skal vise det.
 *
 * `null` for widget-slides: de hentes med ekte tall av selve displayet, og et
 * utkast av dem ville vært en oppdiktet skjerm. `localMediaUrl` er satt når
 * brukeren nettopp har valgt en fil som ikke er lastet opp ennå — da skal
 * previewen vise den valgte fila, ikke den forrige.
 */
export function draftSlideFromForm(
  form: FormState,
  localMediaUrl: string | null,
): SalesDisplaySlide | null {
  if (form.kind === "widget") return null;
  return {
    id: form.id ?? "utkast",
    kind: form.kind,
    title: form.title,
    body: form.body.trim() ? form.body : null,
    mediaPath: form.mediaPath,
    mediaUrl: localMediaUrl ?? form.mediaUrl,
    widgetKey: null,
    durationSeconds: form.durationSeconds,
    sortOrder: 0,
    isActive: form.isActive,
  };
}
